





  import {Component, Mixins} from 'vue-property-decorator';
  import SymbolMixin from "@mixins/symbolMixin";
  import CurrencyMixin from "@mixins/currencyMixin";
  import {eventBus} from '@shared/src/services/eventBus';
  import {authService} from "@services/authService";
  import ConstantMixin from "@mixins/constantMixin";
  import {AuthRepo} from "@services/repos/authRepo";
  import {ES, LS, SS} from "@services/ls";
  import WsMixin from "@mixins/wsMixin";

  const appIcons: Record<string, string> = {
    // Menu icons.
    'menu:dashboard': `svguse:icons/menu.svg#dashboard`,
    'menu:main': `svguse:icons/menu.svg#main`,
    'menu:accounts': `svguse:icons/menu.svg#accounts`,
    'menu:clientBalances': `svguse:icons/menu.svg#clientBalances`,
    'menu:quests': `svguse:icons/menu.svg#quests`,
    'menu:userVerifications': `svguse:icons/menu.svg#userVerifications`,
    'menu:cardVerifications': `svguse:icons/menu.svg#cardVerifications`,
    'menu:lpSettings': `svguse:icons/menu.svg#lpSettings`,
    'menu:operations': `svguse:icons/menu.svg#operations`,
    'menu:orders': `svguse:icons/menu.svg#orders`,
    'menu:trades': `svguse:icons/menu.svg#trades`,
    'menu:funding': `svguse:icons/menu.svg#funding`,
    'menu:ledger': `svguse:icons/menu.svg#ledger`,
    'menu:incomeExpenses': `svguse:icons/menu.svg#incomeExpenses`,
    'menu:positions': `svguse:icons/menu.svg#positions`,
    'menu:dailyPositions': `svguse:icons/menu.svg#dailyPositions`,
    'menu:exchangersComparison': `svguse:icons/menu.svg#exchangersComparison`,
    'menu:managementAccounting': `svguse:icons/menu.svg#managementAccounting`,
    'menu:counterparties': `svguse:icons/menu.svg#counterparties`,
    'menu:marketManagement': `svguse:icons/menu.svg#marketManagement`,
    'menu:currencies': `svguse:icons/menu.svg#currencies`,
    'menu:assetProcessing': `svguse:icons/menu.svg#assetProcessing`,
    'menu:fees': `svguse:icons/menu.svg#fees`,
    'menu:limits': `svguse:icons/menu.svg#limits`,
    'menu:matcherOrders': `svguse:icons/menu.svg#matcherOrders`,
    'menu:htmlPages': `svguse:icons/menu.svg#htmlPages`,
    'menu:exchangeSettings': `svguse:icons/menu.svg#exchangeSettings`,
    'menu:admins': `svguse:icons/menu.svg#admins`,
    'menu:kytList': `svguse:icons/menu.svg#kytList`,

    // Main icons.
    'main:arrow': `svguse:icons/main.svg#arrow`,
    'main:menu': `svguse:icons/main.svg#menu`,
    'main:account_balance_wallet': `svguse:icons/main.svg#account_balance_wallet`,
  }

@Component
export default class App extends Mixins(SymbolMixin, CurrencyMixin, ConstantMixin, WsMixin) {

  authRepo!: AuthRepo;

  //------------------------------------------

  constructor() {
    super();
    this.authRepo = new AuthRepo();
  }

  //------------------------------------------

  init() {
    // this._wsRefresh()
    this.subscribe()

    this._wsSubscribe()
  }

  subscribe() {
    eventBus.$on(this._CONST.event.refresh, () => {
      authService.refresh()
    })

    eventBus.$on(this._CONST.event.logout, () => {
      authService.logOut()
    })

    eventBus.$on(this._CONST.event.welcome, (res: any) => {
      const accessCsrfToken = res.data.accessCsrfToken

      if (accessCsrfToken) {
        ES.set(this._CONST.lsKeys.accessToken, accessCsrfToken)
        this.$store.commit('main/setAccessToken', accessCsrfToken)
      }
    })
  }

  refresh() {
    authService.refresh()
  }

  //------------------------------------------

  created () {
    this.$q.iconMapFn = (name) => appIcons[name] ? { icon: appIcons[name] } : void 0
  }

  mounted() {
    this.init()
  }

}
